import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import { Switch } from '../components/ui/switch';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../components/ui/dialog';
import { MailYonetimiPanel } from '../components/admin/MailYonetimiPanel';
import { SistemPanel } from '../components/admin/SistemPanel';
import { DenetimKaydiPanel } from '../components/admin/DenetimKaydiPanel';
import { BakimModuPanel } from '../components/admin/BakimModuPanel';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULTS = {
  hero_name: 'Cagatay',
  hero_surname: 'Turna',
  hero_subtitle: 'Insaat Yüksek Mühendisi | Yatirim ve Insaat Yonetimi',
  about_paragraph1: 'Yatirim ve insaat sektöründe deneyime sahip bir Insaat Yüksek Mühendisiyim. Proje yonetimi, ihale süreçleri, yapi denetimi ve kurumsal is takibi konularinda uzmanlasmis bulunmaktayim.',
  about_paragraph2: 'Istanbul Gençlik ve Spor Il Müdürlügü Yatirim ve Insaat Sube Müdürlügünde çalismaktayim. Istanbul Arel Üniversitesinde Insaat Mühendisligi üzerine Deprem Mühendisligi alaninda Doktora egitimime devam etmekteyim.',
  education: [
    { year: '2023 - Devam', deg: 'Doktora - Insaat Mühendisligi', school: 'Istanbul Arel Üniversitesi' },
    { year: '2019 - 2021', deg: 'Yüksek Lisans (Tezli) - Insaat Müh. (3.94/4)', school: 'Istanbul Aydin Üniversitesi' },
    { year: '2003 - 2007', deg: 'Lisans - Insaat Mühendisligi', school: 'Dumlupinar Üniversitesi' },
  ],
  expertise: [
    { title: 'Yapi Denetimi ve Kontrollük', desc: 'Spor tesisleri, yurt binalari ve kamu yapilarinin kontrollügü ve is programi takibi' },
    { title: 'Ihale ve Mevzuat', desc: '4734 sayili KIK, yapim ihaleleri, hakedis, yaklasik maliyet ve sözlesme yönetimi' },
    { title: 'Deprem Performans Analizi', desc: 'TBDY 2018 kapsaminda mevcut yapilarin performans degerlendirmesi ve güçlendirme' },
    { title: 'Dijital Dönüsüm', desc: 'Is süreçlerinin dijitallestirmesi ve Kurumsal Is Yönetimi Platformu gelistirme' },
  ],
  technical_software: ['SAP2000','ETABS','Prota Structure','ideCAD','AutoCAD','MS Office (Ileri)','OSKA/AMP Hakedis','Nivo','XTRACT'],
  stats: [
    { value: '18+', label: 'Yil Deneyim' },
    { value: '5', label: 'Akademik Yayin' },
    { value: '10+', label: 'Ekip Üyesi' },
  ],
  publications: [
    { year: '2020', type: 'Makale', title: 'Türkiye Bina Deprem Yönetmeligine Göre Mevcut Betonarme Binanin Performansinin Ve Zemin Etkilesiminin Degerlendirilmesi', journal: 'Bilecik Seyh Edebali Üniversitesi Fen Bilimleri Dergisi, 7(2), 1004-1014', doi: '10.35193/bseufbd.727437' },
    { year: '2021', type: 'Kongre', title: 'Farkli Kat Adetlerine Sahip Betonarme Yapilarin Dogrusal Olmayan Statik Itme Analizine Göre Tasarim Sonuçlarinin TBDY 2019 Kapsaminda Degerlendirilmesi', journal: 'Uluslararasi Mühendislik ve Doga Bilimleri Çalismalari Kongresi (ICENSS2021)', doi: '' },
    { year: '2021', type: 'Makale', title: 'Evaluation of The Performance Of An Existing Reinforced Concrete Grandstand According To TBDY 2019', journal: 'MAS Journal of Applied Sciences, 6(2), 433-445', doi: '10.52520/masjaps.77' },
    { year: '2021', type: 'Makale', title: 'Comparison of Contract Types for Turnkey Lump Sum-Unit Price Proposal Procedure in Repair-Renovation Tenders', journal: 'MAS Journal of Applied Sciences, 6(1), 186-193', doi: '10.52520/masjaps.70' },
    { year: '2021', type: 'Tez', title: 'Evaluation of the design results according to nonlinear static push-up analysis of two reinforced concrete structures with different floor quantities within the scope of TBDY 2019', journal: 'Yüksek Lisans Tezi - Istanbul Aydin Üniversitesi', doi: '' },
  ],
  platform_title: 'Kurumsal Is Yonetimi Platformu',
  platform_description: 'Görev takibi, ihale yönetimi, ödenek kontrolü, hakedis takibi ve daha fazlasi tek platformda.',
  contact_email: 'turna.cagatay@gmail.com',
  contact_phone: '+90 554 829 11 87',
  contact_instagram: 'https://www.instagram.com/cgtytrn',
  contact_instagram_handle: '@cgtytrn',
  contact_linkedin: 'https://www.linkedin.com/in/cagatayturna',
  contact_linkedin_handle: 'cagatayturna',
  contact_location: 'Istanbul, Türkiye',
  footer_text: '2026 Cagatay Turna. Tüm haklari saklidir.'
};

const SMS_VARSAYILAN_SABLONLAR = {
  atama: 'Yeni gorev ataniniz. Gorev: {gorev} Son tarih: {son_tarih} Atayan: {atayan} - Kurumsal Is Yonetimi',
  durum: 'Gorev durumu degisti. Gorev: {gorev} Son tarih: {son_tarih} - Kurumsal Is Yonetimi',
  hatirlatma: 'Gorev Hatirlatma ({sayi} aktif gorev):\n{gorevler}\n- Kurumsal Is Yonetimi',
};
const SMS_SABLON_TANIMLARI = [
  { key: 'atama', baslik: '① Yeni Görev Atama', aciklama: 'Bir kullanıcıya yeni görev atandığında veya görev ataması değiştiğinde gönderilir', degiskenler: ['{gorev}', '{aciklama}', '{son_tarih}', '{oncelik}', '{atayan}'] },
  { key: 'durum', baslik: '② Görev Durumu Değişikliği', aciklama: 'Görevin durumu güncellendiğinde atanan kişiye gönderilir', degiskenler: ['{gorev}', '{aciklama}', '{son_tarih}', '{oncelik}', '{atayan}'] },
  { key: 'hatirlatma', baslik: '③ Görev Hatırlatma', aciklama: 'Zamanlanmış hatırlatmalarda kullanıcının aktif görev listesiyle gönderilir', degiskenler: ['{ad}', '{sayi}', '{gorevler}'] },
];
const SMS_ORNEK_DEGERLER = {
  gorev: 'Santiye kontrol yapilacak', aciklama: 'Temel kazi kontrolu', son_tarih: '2026-08-15',
  oncelik: 'Yuksek', atayan: 'Admin', ad: 'Ahmet Yilmaz', sayi: '3',
  gorevler: '1- Santiye kontrol (2 gun kaldi)\n2- Hakedis dosyasi (BUGUN!)\n3- Proje teslimi (Son: 2026-08-20)',
};
const SMS_TUR_ETIKET = { gorev_atama: 'Görev Atama', durum_degisikligi: 'Durum Değişikliği', hatirlatma: 'Hatırlatma', atama_degisikligi: 'Atama Değişikliği', test: 'Test' };
const smsOnizle = (sablon) => {
  if (!sablon || !sablon.trim()) return '';
  let s = sablon;
  Object.entries(SMS_ORNEK_DEGERLER).forEach(([k, v]) => { s = s.split('{' + k + '}').join(v); });
  return s;
};

const SiteAdminPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(() => new URLSearchParams(window.location.search).get('tab') || 'overview');
  const [finajanEnabled, setFinajanEnabled] = useState(false);
  const [finajanLoading, setFinajanLoading] = useState(true);
  const [content, setContent] = useState(DEFAULTS);
  const [contentLoading, setContentLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState('');
  const [editPubDialog, setEditPubDialog] = useState(false);
  const [editPubIndex, setEditPubIndex] = useState(-1);
  const [editPubData, setEditPubData] = useState({ year: '', type: 'Makale', title: '', journal: '', doi: '' });
  const [editEduDialog, setEditEduDialog] = useState(false);
  const [editEduIndex, setEditEduIndex] = useState(-1);
  const [editEduData, setEditEduData] = useState({ year: '', deg: '', school: '' });
  const [editExpDialog, setEditExpDialog] = useState(false);
  const [editExpIndex, setEditExpIndex] = useState(-1);
  const [editExpData, setEditExpData] = useState({ title: '', desc: '' });
  const [previewOpen, setPreviewOpen] = useState(false);
  const [smsSettings, setSmsSettings] = useState(null);
  const [smsLogs, setSmsLogs] = useState([]);
  const [smsTestPhone, setSmsTestPhone] = useState('');
  const [smsSaving, setSmsSaving] = useState(false);
  const [smsMsg, setSmsMsg] = useState('');
  const [bakimOn, setBakimOn] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings/maintenance`).then(r => setBakimOn(!!r.data?.enabled)).catch(() => {});
  }, []);

  const fetchFinajanStatus = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/settings/finajan-status`, { withCredentials: true });
      setFinajanEnabled(res.data.enabled);
    } catch { setFinajanEnabled(false); }
    finally { setFinajanLoading(false); }
  }, []);

  const fetchContent = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/settings/homepage`);
      if (res.data && !res.data.exists === false) {
        const merged = { ...DEFAULTS };
        Object.keys(res.data).forEach(k => {
          if (res.data[k] !== null && res.data[k] !== undefined) merged[k] = res.data[k];
        });
        setContent(merged);
      }
    } catch { /* use defaults */ }
    finally { setContentLoading(false); }
  }, []);

  useEffect(() => {
    fetchFinajanStatus();
    fetchContent();
  }, [fetchFinajanStatus, fetchContent]);

  // SMS Yönetimi
  const loadSms = useCallback(async () => {
    try {
      const [s, l] = await Promise.all([
        axios.get(`${API}/sms-settings`, { withCredentials: true }),
        axios.get(`${API}/sms-logs`, { withCredentials: true }),
      ]);
      const data = s.data || {};
      setSmsSettings({
        ...data,
        scenarios: { gorev_atandiginda: true, gorev_durumu_degistiginde: true, gorev_son_tarih_yaklastiginda: false, gorev_son_tarih_gun: 3, ...(data.scenarios || {}) },
        sablonlar: { atama: '', durum: '', hatirlatma: '', ...(data.sablonlar || {}) },
      });
      setSmsLogs(l.data || []);
    } catch (e) { setSmsMsg('❌ SMS ayarları yüklenemedi'); }
  }, []);

  useEffect(() => {
    if (activeTab === 'sms' && user?.is_admin && !smsSettings) loadSms();
  }, [activeTab, user, smsSettings, loadSms]);

  const saveSms = async () => {
    setSmsSaving(true);
    try {
      await axios.post(`${API}/sms-settings`, smsSettings, { withCredentials: true });
      setSmsMsg('✅ SMS ayarları kaydedildi');
    } catch (e) { setSmsMsg('❌ Kaydedilemedi: ' + (e.response?.data?.detail || e.message)); }
    finally { setSmsSaving(false); setTimeout(() => setSmsMsg(''), 4000); }
  };

  const testSms = async () => {
    if (!smsTestPhone) { setSmsMsg('⚠️ Test için telefon numarası girin'); setTimeout(() => setSmsMsg(''), 3000); return; }
    try {
      const res = await axios.post(`${API}/sms-test`, { phone: smsTestPhone, message: 'Test SMS - Kurumsal Is Yonetimi Platformu' }, { withCredentials: true });
      setSmsMsg(res.data.success ? '✅ Test SMS gönderildi' : '❌ Gönderilemedi: ' + (res.data.message || ''));
    } catch (e) { setSmsMsg('❌ Test hatası: ' + (e.response?.data?.detail || e.message)); }
    setTimeout(() => setSmsMsg(''), 5000);
  };


  const toggleFinajan = async (enabled) => {
    setFinajanLoading(true);
    try {
      await axios.put(`${API}/settings/finajan-status`, { enabled }, { withCredentials: true });
      setFinajanEnabled(enabled);
    } catch (e) {
      alert('Hata: ' + (e.response?.data?.detail || e.message));
    } finally { setFinajanLoading(false); }
  };

  const saveContent = async () => {
    setSaving(true);
    setSaveMsg('');
    try {
      await axios.put(`${API}/settings/homepage`, content, { withCredentials: true });
      setSaveMsg('Basariyla kaydedildi!');
      setTimeout(() => setSaveMsg(''), 3000);
    } catch (e) {
      setSaveMsg('Hata: ' + (e.response?.data?.detail || e.message));
    } finally { setSaving(false); }
  };

  // Publication helpers
  const openPubEdit = (index) => {
    if (index >= 0) setEditPubData({ ...content.publications[index] });
    else setEditPubData({ year: '', type: 'Makale', title: '', journal: '', doi: '' });
    setEditPubIndex(index);
    setEditPubDialog(true);
  };
  const savePub = () => {
    const pubs = [...(content.publications || [])];
    if (editPubIndex >= 0) pubs[editPubIndex] = editPubData;
    else pubs.push(editPubData);
    setContent({ ...content, publications: pubs });
    setEditPubDialog(false);
  };
  const deletePub = (index) => {
    const pubs = [...(content.publications || [])];
    pubs.splice(index, 1);
    setContent({ ...content, publications: pubs });
  };

  // Education helpers
  const openEduEdit = (index) => {
    if (index >= 0) setEditEduData({ ...content.education[index] });
    else setEditEduData({ year: '', deg: '', school: '' });
    setEditEduIndex(index);
    setEditEduDialog(true);
  };
  const saveEdu = () => {
    const list = [...(content.education || [])];
    if (editEduIndex >= 0) list[editEduIndex] = editEduData;
    else list.push(editEduData);
    setContent({ ...content, education: list });
    setEditEduDialog(false);
  };
  const deleteEdu = (index) => {
    const list = [...(content.education || [])];
    list.splice(index, 1);
    setContent({ ...content, education: list });
  };

  // Expertise helpers
  const openExpEdit = (index) => {
    if (index >= 0) setEditExpData({ ...content.expertise[index] });
    else setEditExpData({ title: '', desc: '' });
    setEditExpIndex(index);
    setEditExpDialog(true);
  };
  const saveExp = () => {
    const list = [...(content.expertise || [])];
    if (editExpIndex >= 0) list[editExpIndex] = editExpData;
    else list.push(editExpData);
    setContent({ ...content, expertise: list });
    setEditExpDialog(false);
  };
  const deleteExp = (index) => {
    const list = [...(content.expertise || [])];
    list.splice(index, 1);
    setContent({ ...content, expertise: list });
  };

  if (!user?.is_admin) {
    return (
      <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-400 text-lg mb-4">Bu sayfaya erisim yetkiniz bulunmamaktadir.</p>
          <Button onClick={() => navigate('/')} className="bg-amber-600 hover:bg-amber-700">Anasayfaya Dön</Button>
        </div>
      </div>
    );
  }

  const TABS = [
    { id: 'overview', label: 'Genel Bakis' },
    { id: 'bakim', label: bakimOn ? '🔧 Bakım Modu (AÇIK)' : 'Bakım Modu' },
    { id: 'finajan', label: 'FinAjan' },
    { id: 'sms', label: 'SMS Yönetimi' },
    { id: 'mail', label: 'Mail Yönetimi' },
    { id: 'sistem', label: 'Sistem' },
    { id: 'denetim', label: 'Denetim Kaydı' },
    { id: 'hero', label: 'Hero Bölümü' },
    { id: 'about', label: 'Hakkimda' },
    { id: 'publications', label: 'Yayinlar' },
    { id: 'platform', label: 'Platform CTA' },
    { id: 'contact', label: 'Iletisim' },
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      {/* Header */}
      <header className="bg-[#0a0a0a]/95 border-b border-gray-800 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <a href="/" className="text-xl font-light tracking-widest text-white hover:text-amber-400 transition-colors">CAGATAY TURNA</a>
            <span className="text-xs bg-amber-600 text-white px-2 py-0.5 rounded">ADMIN PANEL</span>
          </div>
          <div className="flex items-center gap-4">
            <Button onClick={() => setPreviewOpen(true)} variant="outline" className="border-amber-600 text-amber-400 hover:bg-amber-600/10 text-sm" data-testid="preview-btn">
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
              Önizleme
            </Button>
            <Button onClick={() => navigate('/')} variant="ghost" className="text-gray-300 hover:text-white text-sm">Anasayfa</Button>
            <Button onClick={() => navigate('/dashboard')} variant="ghost" className="text-gray-300 hover:text-white text-sm">Platform</Button>
            <Button onClick={async () => { await logout(); navigate('/login'); }} variant="ghost" className="text-red-400 hover:text-red-300 text-sm">Cikis</Button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 py-8">
        <h1 className="text-3xl font-light tracking-wider mb-2">Admin Panel</h1>
        <p className="text-gray-400 mb-8">Web sitesi ve platform yönetim paneli</p>

        {/* Tab Navigation */}
        <div className="flex flex-wrap gap-1 mb-8 border-b border-gray-800 pb-2">
          {TABS.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2 text-sm rounded-t-lg transition-colors ${activeTab === tab.id ? 'bg-gray-800 text-white border-b-2 border-amber-500' : 'text-gray-400 hover:text-white hover:bg-gray-800/50'}`}
              data-testid={`tab-${tab.id}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* OVERVIEW TAB */}
        {activeTab === 'overview' && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className={`border transition-colors cursor-pointer ${bakimOn ? 'bg-amber-950/30 border-amber-600/60 hover:border-amber-500' : 'bg-gray-900 border-gray-800 hover:border-amber-500/30'}`} onClick={() => setActiveTab('bakim')} data-testid="overview-bakim-card">
              <CardHeader>
                <CardTitle className="text-white text-lg flex items-center gap-2">
                  🔧 Bakım Modu
                  <span className={`ml-auto text-xs px-2 py-0.5 rounded ${bakimOn ? 'bg-amber-600 text-black' : 'bg-gray-700 text-gray-200'}`} data-testid="overview-bakim-badge">
                    {bakimOn ? 'AÇIK' : 'KAPALI'}
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent><p className="text-gray-400 text-sm">Deploy öncesi siteyi bakıma al (ON/OFF) — kullanıcılar veri girişi yapamaz, yöneticiler etkilenmez</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => setActiveTab('finajan')}>
              <CardHeader>
                <CardTitle className="text-white text-lg flex items-center gap-2">
                  <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-xs">FA</span>
                  FinAjan
                  <span className={`ml-auto text-xs px-2 py-0.5 rounded ${finajanEnabled ? 'bg-green-900/50 text-green-400' : 'bg-red-900/50 text-red-400'}`}>
                    {finajanEnabled ? 'AKTIF' : 'KAPALI'}
                  </span>
                </CardTitle>
              </CardHeader>
              <CardContent><p className="text-gray-400 text-sm">AI destekli finans analizi - Acma/kapama kontrolü</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => setActiveTab('sms')} data-testid="overview-sms-card">
              <CardHeader><CardTitle className="text-white text-lg">📱 SMS Yönetimi</CardTitle></CardHeader>
              <CardContent><p className="text-gray-400 text-sm">İleti Merkezi API ayarlari, mesaj sablonlari, test SMS ve gönderim geçmisi</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => setActiveTab('mail')} data-testid="overview-mail-card">
              <CardHeader><CardTitle className="text-white text-lg">✉️ Mail Yönetimi</CardTitle></CardHeader>
              <CardContent><p className="text-gray-400 text-sm">SMTP/IMAP ayarlari, bildirim senaryolari ve test maili</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => setActiveTab('sistem')} data-testid="overview-sistem-card">
              <CardHeader><CardTitle className="text-white text-lg">🖥 Sistem</CardTitle></CardHeader>
              <CardContent><p className="text-gray-400 text-sm">Database yedek indirme, oturum zaman asimi ve aktif oturumlar</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => setActiveTab('denetim')} data-testid="overview-denetim-card">
              <CardHeader><CardTitle className="text-white text-lg">🛡 Denetim Kaydı</CardTitle></CardHeader>
              <CardContent><p className="text-gray-400 text-sm">Kim ne zaman ne yapti: tüm islem gecmisi (90 gün)</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => navigate('/admin/users')}>
              <CardHeader><CardTitle className="text-white text-lg">Kullanici Yönetimi</CardTitle></CardHeader>
              <CardContent><p className="text-gray-400 text-sm">Kullanicilar, yetkiler, Mail ayarlari, oturumlar ve denetim kaydi</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => navigate('/dashboard')}>
              <CardHeader><CardTitle className="text-white text-lg">Kurumsal Is Yönetimi</CardTitle></CardHeader>
              <CardContent><p className="text-gray-400 text-sm">Görevler, Ihaleler, Ödenek, Hakedis, Bakim-Onarim modülleri</p></CardContent>
            </Card>
            <Card className="bg-gray-900 border-gray-800 hover:border-amber-500/30 transition-colors cursor-pointer" onClick={() => setActiveTab('hero')}>
              <CardHeader><CardTitle className="text-white text-lg">Site Ayarlari</CardTitle></CardHeader>
              <CardContent><p className="text-gray-400 text-sm">Anasayfa içerikleri, hakkimda, yayinlar düzenleme</p></CardContent>
            </Card>
          </div>
        )}

        {/* BAKIM MODU TAB */}
        {activeTab === 'bakim' && <BakimModuPanel onChange={setBakimOn} />}

        {/* SMS YONETIMI TAB */}
        {activeTab === 'sms' && (
          <div className="space-y-6" data-testid="sms-yonetim-panel">
            {smsMsg && <div className="p-3 bg-gray-800 border border-amber-700/50 rounded-lg text-sm text-white" data-testid="sms-panel-msg">{smsMsg}</div>}
            {!smsSettings ? (
              <p className="text-gray-400">SMS ayarları yükleniyor…</p>
            ) : (
              <>
                <div className="grid lg:grid-cols-2 gap-6">
                  <Card className="bg-gray-900 border-gray-800">
                    <CardHeader>
                      <CardTitle className="text-white text-lg">API Ayarları (İleti Merkezi)</CardTitle>
                      <CardDescription className="text-gray-500 text-xs">panel.iletimerkezi.com → Ayarlar → API sekmesinden API Key ve Hash bilgilerinizi alın</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-3">
                      <div className="space-y-1">
                        <Label className="text-gray-300 text-xs">API Anahtarı (Key)</Label>
                        <Input value={smsSettings.api_key || ''} onChange={(e) => setSmsSettings({ ...smsSettings, api_key: e.target.value })} className="bg-gray-800 border-gray-700 text-white text-sm h-9" data-testid="sms-api-key-input" />
                      </div>
                      <div className="space-y-1">
                        <Label className="text-gray-300 text-xs">Secret Key (Hash)</Label>
                        <Input value={smsSettings.secret_key || ''} onChange={(e) => setSmsSettings({ ...smsSettings, secret_key: e.target.value })} className="bg-gray-800 border-gray-700 text-white text-sm h-9" data-testid="sms-secret-key-input" />
                      </div>
                      <div className="space-y-1">
                        <Label className="text-gray-300 text-xs">Gönderici Adı (Sender)</Label>
                        <Input value={smsSettings.sms_sender || ''} onChange={(e) => setSmsSettings({ ...smsSettings, sms_sender: e.target.value })} className="bg-gray-800 border-gray-700 text-white text-sm h-9" placeholder="Paneldeki onaylı gönderici başlığınız" data-testid="sms-sender-input" />
                      </div>
                      <div className="flex items-center justify-between pt-2 border-t border-gray-800">
                        <div>
                          <p className="text-white text-sm font-medium">SMS Bildirimleri</p>
                          <p className="text-gray-500 text-xs">Tüm SMS gönderimini aç/kapat</p>
                        </div>
                        <Switch checked={!!smsSettings.sms_enabled} onCheckedChange={(v) => setSmsSettings({ ...smsSettings, sms_enabled: v })} data-testid="sms-enabled-switch" />
                      </div>
                      <div className="flex gap-2 pt-2 border-t border-gray-800">
                        <Input value={smsTestPhone} onChange={(e) => setSmsTestPhone(e.target.value)} className="bg-gray-800 border-gray-700 text-white text-sm h-9" placeholder="Test: 05XX XXX XX XX" data-testid="sms-test-phone-input" />
                        <Button onClick={testSms} size="sm" className="bg-amber-600 hover:bg-amber-700 text-white h-9 px-4 flex-shrink-0" data-testid="sms-test-btn">Test Gönder</Button>
                      </div>
                    </CardContent>
                  </Card>

                  <Card className="bg-gray-900 border-gray-800">
                    <CardHeader>
                      <CardTitle className="text-white text-lg">Gönderim Senaryoları</CardTitle>
                      <CardDescription className="text-gray-500 text-xs">Hangi olaylarda SMS gönderileceğini seçin</CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-2">
                      {[
                        { key: 'gorev_atandiginda', label: 'Görev atandığında', desc: 'Yeni görev atanan kişiye SMS gider' },
                        { key: 'gorev_durumu_degistiginde', label: 'Görev durumu değiştiğinde', desc: 'Durum güncellenince atanan kişiye SMS gider' },
                        { key: 'gorev_son_tarih_yaklastiginda', label: 'Son tarih yaklaştığında', desc: "Görev son tarihi yaklaşınca hatırlatma SMS'i" },
                      ].map((s) => (
                        <div key={s.key} className="flex items-center justify-between py-2 border-b border-gray-800 last:border-0">
                          <div>
                            <p className="text-gray-200 text-sm">{s.label}</p>
                            <p className="text-gray-500 text-xs">{s.desc}</p>
                          </div>
                          <Switch checked={!!smsSettings.scenarios?.[s.key]} onCheckedChange={(v) => setSmsSettings({ ...smsSettings, scenarios: { ...smsSettings.scenarios, [s.key]: v } })} data-testid={`sms-senaryo-${s.key}`} />
                        </div>
                      ))}
                      {smsSettings.scenarios?.gorev_son_tarih_yaklastiginda && (
                        <div className="flex items-center gap-2 pl-1 pt-1">
                          <span className="text-gray-400 text-xs">Kaç gün önce:</span>
                          <Input type="number" min="1" max="30" value={smsSettings.scenarios?.gorev_son_tarih_gun || 3} onChange={(e) => setSmsSettings({ ...smsSettings, scenarios: { ...smsSettings.scenarios, gorev_son_tarih_gun: parseInt(e.target.value) || 3 } })} className="bg-gray-800 border-gray-700 text-white text-xs h-7 w-16" />
                          <span className="text-gray-400 text-xs">gün</span>
                        </div>
                      )}
                    </CardContent>
                  </Card>
                </div>

                <Card className="bg-gray-900 border-gray-800">
                  <CardHeader>
                    <CardTitle className="text-white text-lg">Mesaj Şablonları</CardTitle>
                    <CardDescription className="text-gray-500 text-xs">
                      Gönderilen SMS metnini kendiniz yazın; süslü parantezli değişkenler gönderim anında gerçek verilerle değiştirilir (değişken rozetine tıklayarak şablona ekleyebilirsiniz).
                      Şablonu <b className="text-gray-400">boş bırakırsanız</b> sistemin otomatik varsayılan mesajı kullanılır. Not: Türkçe karakterler SMS karakter sayısını artırabilir.
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="space-y-5">
                    {SMS_SABLON_TANIMLARI.map((t) => (
                      <div key={t.key} className="p-4 bg-gray-800/40 rounded-lg border border-gray-800 space-y-2" data-testid={`sms-sablon-${t.key}`}>
                        <div className="flex items-center justify-between flex-wrap gap-2">
                          <div>
                            <p className="text-white text-sm font-semibold">{t.baslik}</p>
                            <p className="text-gray-500 text-xs">{t.aciklama}</p>
                          </div>
                          <div className="flex gap-2">
                            <Button size="sm" variant="outline" className="border-gray-700 bg-transparent text-gray-300 hover:text-white h-7 text-xs" onClick={() => setSmsSettings({ ...smsSettings, sablonlar: { ...smsSettings.sablonlar, [t.key]: SMS_VARSAYILAN_SABLONLAR[t.key] } })} data-testid={`sms-sablon-varsayilan-${t.key}`}>Varsayılanı Yükle</Button>
                            <Button size="sm" variant="outline" className="border-gray-700 bg-transparent text-gray-400 hover:text-white h-7 text-xs" onClick={() => setSmsSettings({ ...smsSettings, sablonlar: { ...smsSettings.sablonlar, [t.key]: '' } })} data-testid={`sms-sablon-temizle-${t.key}`}>Temizle</Button>
                          </div>
                        </div>
                        <div className="flex flex-wrap gap-1.5">
                          {t.degiskenler.map((d) => (
                            <button key={d} onClick={() => setSmsSettings({ ...smsSettings, sablonlar: { ...smsSettings.sablonlar, [t.key]: (smsSettings.sablonlar[t.key] || '') + (smsSettings.sablonlar[t.key] ? ' ' : '') + d } })}
                              className="text-xs bg-amber-900/30 text-amber-300 border border-amber-800/50 px-2 py-0.5 rounded hover:bg-amber-800/40 transition-colors" title="Şablona ekle" data-testid={`sms-degisken-${t.key}-${d.replace(/[{}]/g, '')}`}>{d}</button>
                          ))}
                        </div>
                        <Textarea value={smsSettings.sablonlar[t.key] || ''} onChange={(e) => setSmsSettings({ ...smsSettings, sablonlar: { ...smsSettings.sablonlar, [t.key]: e.target.value } })}
                          rows={t.key === 'hatirlatma' ? 4 : 3} className="bg-gray-800 border-gray-700 text-white text-sm font-mono"
                          placeholder={'Boş bırakılırsa otomatik varsayılan mesaj kullanılır. Örnek: ' + SMS_VARSAYILAN_SABLONLAR[t.key].split('\n')[0]} data-testid={`sms-sablon-input-${t.key}`} />
                        {(smsSettings.sablonlar[t.key] || '').trim() && (
                          <div className="p-2 bg-gray-950 rounded border border-gray-800">
                            <p className="text-[10px] uppercase tracking-wider text-gray-500 mb-1">Canlı Önizleme · {smsOnizle(smsSettings.sablonlar[t.key]).length} karakter</p>
                            <p className="text-xs text-green-300 whitespace-pre-wrap" data-testid={`sms-sablon-onizleme-${t.key}`}>{smsOnizle(smsSettings.sablonlar[t.key])}</p>
                          </div>
                        )}
                      </div>
                    ))}
                  </CardContent>
                </Card>

                <div className="flex items-center gap-3">
                  <Button onClick={saveSms} disabled={smsSaving} className="bg-blue-600 hover:bg-blue-700 text-white px-8" data-testid="sms-kaydet-btn">{smsSaving ? 'Kaydediliyor…' : 'Tüm SMS Ayarlarını Kaydet'}</Button>
                </div>

                <Card className="bg-gray-900 border-gray-800">
                  <CardHeader>
                    <div className="flex items-center justify-between">
                      <div>
                        <CardTitle className="text-white text-lg">SMS Gönderim Geçmişi</CardTitle>
                        <CardDescription className="text-gray-500 text-xs">{smsLogs.length} kayıt · son gönderimler üstte</CardDescription>
                      </div>
                      <Button size="sm" variant="outline" className="border-gray-700 bg-transparent text-gray-300 hover:text-white h-8 text-xs" onClick={loadSms} data-testid="sms-log-yenile-btn">Yenile</Button>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="overflow-x-auto max-h-96 overflow-y-auto">
                      <table className="w-full text-sm">
                        <thead className="bg-gray-800 sticky top-0">
                          <tr>
                            <th className="px-3 py-2 text-left text-xs text-gray-300">Tarih</th>
                            <th className="px-3 py-2 text-left text-xs text-gray-300">Alıcı</th>
                            <th className="px-3 py-2 text-left text-xs text-gray-300">Telefon</th>
                            <th className="px-3 py-2 text-left text-xs text-gray-300">Tür</th>
                            <th className="px-3 py-2 text-left text-xs text-gray-300">Mesaj</th>
                            <th className="px-3 py-2 text-left text-xs text-gray-300">Durum</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-800">
                          {smsLogs.slice(0, 100).map((log, idx) => (
                            <tr key={`${log.sent_at}-${idx}`} className="hover:bg-gray-800/50">
                              <td className="px-3 py-2 text-gray-300 text-xs whitespace-nowrap">{log.sent_at ? new Date(log.sent_at).toLocaleString('tr-TR') : '-'}</td>
                              <td className="px-3 py-2 text-white text-xs">{log.recipient_name || '-'}</td>
                              <td className="px-3 py-2 text-gray-400 text-xs">{log.phone}</td>
                              <td className="px-3 py-2 text-gray-400 text-xs">{SMS_TUR_ETIKET[log.sms_type] || log.sms_type || '-'}</td>
                              <td className="px-3 py-2 text-gray-400 text-xs max-w-xs truncate" title={log.message}>{log.message}</td>
                              <td className="px-3 py-2"><span className={`text-xs font-medium ${log.success ? 'text-green-400' : 'text-red-400'}`}>{log.success ? 'Gönderildi' : 'Başarısız'}</span></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      {smsLogs.length === 0 && <p className="text-center py-8 text-gray-500">Henüz SMS kaydı yok</p>}
                    </div>
                  </CardContent>
                </Card>
              </>
            )}
          </div>
        )}

        {/* MAIL / SISTEM / DENETIM TABLARI */}
        {activeTab === 'mail' && <MailYonetimiPanel />}
        {activeTab === 'sistem' && <SistemPanel />}
        {activeTab === 'denetim' && <DenetimKaydiPanel />}

        {/* FINAJAN TAB */}
        {activeTab === 'finajan' && (
          <div className="max-w-xl">
            <Card className="bg-gray-900 border-gray-800" data-testid="finajan-toggle-card">
              <CardHeader>
                <CardTitle className="text-white text-lg flex items-center gap-3">
                  <span className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center text-white font-bold text-sm">FA</span>
                  FinAjan Kontrol
                </CardTitle>
                <CardDescription className="text-gray-400">
                  FinAjan programinin arka plan islemlerini (piyasa verisi çekme, sinyal hesaplama, cache güncelleme) açip kapatabilirsiniz.
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="flex items-center justify-between p-4 bg-gray-800 rounded-lg">
                  <div>
                    <p className="text-white font-medium">FinAjan Durumu</p>
                    <p className="text-sm text-gray-400">
                      {finajanEnabled ? 'Aktif - Arka planda veri çekiliyor' : 'Kapali - Arka plan islemleri durduruldu'}
                    </p>
                  </div>
                  <Switch
                    checked={finajanEnabled}
                    onCheckedChange={(checked) => toggleFinajan(checked)}
                    disabled={finajanLoading}
                    data-testid="finajan-toggle-switch"
                  />
                </div>
                <div className={`p-4 rounded-lg border ${finajanEnabled ? 'bg-green-900/20 border-green-700/50' : 'bg-red-900/20 border-red-700/50'}`}>
                  <div className="flex items-center gap-2 mb-2">
                    <div className={`w-3 h-3 rounded-full ${finajanEnabled ? 'bg-green-400 animate-pulse' : 'bg-red-400'}`}></div>
                    <span className={`font-medium ${finajanEnabled ? 'text-green-400' : 'text-red-400'}`}>
                      {finajanEnabled ? 'AKTIF' : 'DEVRE DISI'}
                    </span>
                  </div>
                  <ul className="text-sm text-gray-400 space-y-1 ml-5">
                    <li>Cache Scheduler (5dk): {finajanEnabled ? 'Calisiyor' : 'Durduruldu'}</li>
                    <li>Piyasa Verisi Çekme: {finajanEnabled ? 'Aktif' : 'Durduruldu'}</li>
                    <li>Sinyal Hesaplama: {finajanEnabled ? 'Aktif' : 'Durduruldu'}</li>
                    <li>API Endpoint Erisimi: {finajanEnabled ? 'Açik' : 'Kapali'}</li>
                  </ul>
                </div>
                {finajanEnabled && (
                  <Button onClick={() => navigate('/finajan')} className="w-full bg-blue-600 hover:bg-blue-700">
                    FinAjan Paneline Git
                  </Button>
                )}
              </CardContent>
            </Card>
          </div>
        )}

        {/* HERO TAB */}
        {activeTab === 'hero' && (
          <div className="max-w-2xl space-y-6">
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader>
                <CardTitle className="text-white">Hero Bölümü</CardTitle>
                <CardDescription className="text-gray-400">Anasayfanin üst kismi</CardDescription>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-white">Ad</Label>
                    <Input value={content.hero_name} onChange={(e) => setContent({ ...content, hero_name: e.target.value })} className="bg-gray-800 border-gray-700 text-white" data-testid="hero-name-input" />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-white">Soyad</Label>
                    <Input value={content.hero_surname} onChange={(e) => setContent({ ...content, hero_surname: e.target.value })} className="bg-gray-800 border-gray-700 text-white" data-testid="hero-surname-input" />
                  </div>
                </div>
                <div className="space-y-2">
                  <Label className="text-white">Alt Baslik</Label>
                  <Input value={content.hero_subtitle} onChange={(e) => setContent({ ...content, hero_subtitle: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                </div>
                <Button onClick={saveContent} disabled={saving} className="bg-amber-600 hover:bg-amber-700" data-testid="save-hero-btn">{saving ? 'Kaydediliyor...' : 'Kaydet'}</Button>
                {saveMsg && <p className={`text-sm ${saveMsg.includes('Hata') ? 'text-red-400' : 'text-green-400'}`}>{saveMsg}</p>}
              </CardContent>
            </Card>
          </div>
        )}

        {/* ABOUT TAB */}
        {activeTab === 'about' && (
          <div className="max-w-3xl space-y-6">
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader>
                <CardTitle className="text-white">Hakkimda Metni</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <Label className="text-white">Paragraf 1</Label>
                  <Textarea value={content.about_paragraph1} onChange={(e) => setContent({ ...content, about_paragraph1: e.target.value })} className="bg-gray-800 border-gray-700 text-white" rows={4} />
                </div>
                <div className="space-y-2">
                  <Label className="text-white">Paragraf 2</Label>
                  <Textarea value={content.about_paragraph2} onChange={(e) => setContent({ ...content, about_paragraph2: e.target.value })} className="bg-gray-800 border-gray-700 text-white" rows={4} />
                </div>
              </CardContent>
            </Card>

            {/* Education */}
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-white">Egitim</CardTitle>
                  <Button onClick={() => openEduEdit(-1)} size="sm" className="bg-amber-600 hover:bg-amber-700">+ Ekle</Button>
                </div>
              </CardHeader>
              <CardContent className="space-y-2">
                {(content.education || []).map((edu, i) => (
                  <div key={i} className="flex items-center gap-3 p-3 bg-gray-800 rounded-lg">
                    <span className="text-xs text-amber-400 w-28 shrink-0">{edu.year}</span>
                    <div className="flex-1 min-w-0">
                      <p className="text-white text-sm truncate">{edu.deg}</p>
                      <p className="text-gray-500 text-xs">{edu.school}</p>
                    </div>
                    <Button onClick={() => openEduEdit(i)} size="sm" variant="ghost" className="text-blue-400 shrink-0">Düzenle</Button>
                    <Button onClick={() => deleteEdu(i)} size="sm" variant="ghost" className="text-red-400 shrink-0">Sil</Button>
                  </div>
                ))}
              </CardContent>
            </Card>

            {/* Expertise */}
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-white">Uzmanlik Alanlari</CardTitle>
                  <Button onClick={() => openExpEdit(-1)} size="sm" className="bg-amber-600 hover:bg-amber-700">+ Ekle</Button>
                </div>
              </CardHeader>
              <CardContent className="space-y-2">
                {(content.expertise || []).map((exp, i) => (
                  <div key={i} className="flex items-center gap-3 p-3 bg-gray-800 rounded-lg">
                    <div className="flex-1 min-w-0">
                      <p className="text-white text-sm">{exp.title}</p>
                      <p className="text-gray-500 text-xs truncate">{exp.desc}</p>
                    </div>
                    <Button onClick={() => openExpEdit(i)} size="sm" variant="ghost" className="text-blue-400 shrink-0">Düzenle</Button>
                    <Button onClick={() => deleteExp(i)} size="sm" variant="ghost" className="text-red-400 shrink-0">Sil</Button>
                  </div>
                ))}
              </CardContent>
            </Card>

            {/* Stats */}
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader><CardTitle className="text-white">Istatistikler</CardTitle></CardHeader>
              <CardContent>
                <div className="grid grid-cols-3 gap-4">
                  {(content.stats || []).map((stat, i) => (
                    <div key={i} className="space-y-2">
                      <Input value={stat.value} onChange={(e) => { const s = [...content.stats]; s[i] = { ...s[i], value: e.target.value }; setContent({ ...content, stats: s }); }} className="bg-gray-800 border-gray-700 text-amber-400 text-center font-bold" />
                      <Input value={stat.label} onChange={(e) => { const s = [...content.stats]; s[i] = { ...s[i], label: e.target.value }; setContent({ ...content, stats: s }); }} className="bg-gray-800 border-gray-700 text-gray-300 text-center text-xs" />
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>

            {/* Technical Software */}
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader><CardTitle className="text-white">Teknik Yazilimlar</CardTitle></CardHeader>
              <CardContent className="space-y-3">
                <Textarea
                  value={(content.technical_software || []).join(', ')}
                  onChange={(e) => setContent({ ...content, technical_software: e.target.value.split(',').map(s => s.trim()).filter(Boolean) })}
                  className="bg-gray-800 border-gray-700 text-white"
                  rows={2}
                  placeholder="Virgülle ayirin: SAP2000, ETABS, AutoCAD"
                />
                <div className="flex flex-wrap gap-1">
                  {(content.technical_software || []).map((s, i) => (
                    <span key={i} className="text-xs bg-gray-800 text-gray-300 px-2 py-1 rounded border border-gray-700">{s}</span>
                  ))}
                </div>
              </CardContent>
            </Card>

            <Button onClick={saveContent} disabled={saving} className="bg-amber-600 hover:bg-amber-700" data-testid="save-about-btn">{saving ? 'Kaydediliyor...' : 'Tümünü Kaydet'}</Button>
            {saveMsg && <p className={`text-sm ${saveMsg.includes('Hata') ? 'text-red-400' : 'text-green-400'}`}>{saveMsg}</p>}
          </div>
        )}

        {/* PUBLICATIONS TAB */}
        {activeTab === 'publications' && (
          <div className="max-w-3xl space-y-6">
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-white">Yayinlar ({(content.publications || []).length})</CardTitle>
                  <Button onClick={() => openPubEdit(-1)} className="bg-amber-600 hover:bg-amber-700" data-testid="add-publication-btn">+ Yayin Ekle</Button>
                </div>
              </CardHeader>
              <CardContent className="space-y-3">
                {(content.publications || []).map((pub, i) => (
                  <div key={i} className="p-4 bg-gray-800 rounded-lg">
                    <div className="flex items-start gap-4">
                      <div className="text-center shrink-0">
                        <div className="text-lg font-bold text-amber-400">{pub.year}</div>
                        <div className={`text-xs mt-1 px-2 py-0.5 rounded ${pub.type === 'Makale' ? 'bg-blue-900/50 text-blue-300' : pub.type === 'Tez' ? 'bg-purple-900/50 text-purple-300' : 'bg-green-900/50 text-green-300'}`}>{pub.type}</div>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-white text-sm">{pub.title}</p>
                        <p className="text-gray-500 text-xs mt-1">{pub.journal}</p>
                        {pub.doi && <p className="text-amber-600 text-xs mt-1">DOI: {pub.doi}</p>}
                      </div>
                      <div className="flex gap-1 shrink-0">
                        <Button onClick={() => openPubEdit(i)} size="sm" variant="ghost" className="text-blue-400">Düzenle</Button>
                        <Button onClick={() => deletePub(i)} size="sm" variant="ghost" className="text-red-400">Sil</Button>
                      </div>
                    </div>
                  </div>
                ))}
              </CardContent>
            </Card>
            <Button onClick={saveContent} disabled={saving} className="bg-amber-600 hover:bg-amber-700">{saving ? 'Kaydediliyor...' : 'Kaydet'}</Button>
            {saveMsg && <p className={`text-sm ${saveMsg.includes('Hata') ? 'text-red-400' : 'text-green-400'}`}>{saveMsg}</p>}
          </div>
        )}

        {/* PLATFORM CTA TAB */}
        {activeTab === 'platform' && (
          <div className="max-w-2xl space-y-6">
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader><CardTitle className="text-white">Platform CTA Bölümü</CardTitle></CardHeader>
              <CardContent className="space-y-4">
                <div className="space-y-2">
                  <Label className="text-white">Baslik</Label>
                  <Input value={content.platform_title} onChange={(e) => setContent({ ...content, platform_title: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                </div>
                <div className="space-y-2">
                  <Label className="text-white">Aciklama</Label>
                  <Textarea value={content.platform_description} onChange={(e) => setContent({ ...content, platform_description: e.target.value })} className="bg-gray-800 border-gray-700 text-white" rows={3} />
                </div>
                <Button onClick={saveContent} disabled={saving} className="bg-amber-600 hover:bg-amber-700">{saving ? 'Kaydediliyor...' : 'Kaydet'}</Button>
                {saveMsg && <p className={`text-sm ${saveMsg.includes('Hata') ? 'text-red-400' : 'text-green-400'}`}>{saveMsg}</p>}
              </CardContent>
            </Card>
          </div>
        )}

        {/* CONTACT TAB */}
        {activeTab === 'contact' && (
          <div className="max-w-2xl space-y-6">
            <Card className="bg-gray-900 border-gray-800">
              <CardHeader><CardTitle className="text-white">Iletisim Bilgileri</CardTitle></CardHeader>
              <CardContent className="space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-white">E-posta</Label>
                    <Input value={content.contact_email} onChange={(e) => setContent({ ...content, contact_email: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-white">Telefon</Label>
                    <Input value={content.contact_phone} onChange={(e) => setContent({ ...content, contact_phone: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-white">Instagram URL</Label>
                    <Input value={content.contact_instagram} onChange={(e) => setContent({ ...content, contact_instagram: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-white">Instagram Handle</Label>
                    <Input value={content.contact_instagram_handle} onChange={(e) => setContent({ ...content, contact_instagram_handle: e.target.value })} className="bg-gray-800 border-gray-700 text-white" placeholder="@cgtytrn" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-white">LinkedIn URL</Label>
                    <Input value={content.contact_linkedin} onChange={(e) => setContent({ ...content, contact_linkedin: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-white">LinkedIn Handle</Label>
                    <Input value={content.contact_linkedin_handle} onChange={(e) => setContent({ ...content, contact_linkedin_handle: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <Label className="text-white">Konum</Label>
                    <Input value={content.contact_location} onChange={(e) => setContent({ ...content, contact_location: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                  </div>
                  <div className="space-y-2">
                    <Label className="text-white">Footer Metni</Label>
                    <Input value={content.footer_text} onChange={(e) => setContent({ ...content, footer_text: e.target.value })} className="bg-gray-800 border-gray-700 text-white" />
                  </div>
                </div>
                <Button onClick={saveContent} disabled={saving} className="bg-amber-600 hover:bg-amber-700">{saving ? 'Kaydediliyor...' : 'Kaydet'}</Button>
                {saveMsg && <p className={`text-sm ${saveMsg.includes('Hata') ? 'text-red-400' : 'text-green-400'}`}>{saveMsg}</p>}
              </CardContent>
            </Card>
          </div>
        )}
      </div>

      {/* Publication Edit Dialog */}
      <Dialog open={editPubDialog} onOpenChange={setEditPubDialog}>
        <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle>{editPubIndex >= 0 ? 'Yayin Düzenle' : 'Yeni Yayin Ekle'}</DialogTitle>
            <DialogDescription className="text-gray-400">Yayin bilgilerini girin</DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2"><Label>Yil</Label><Input value={editPubData.year} onChange={(e) => setEditPubData({ ...editPubData, year: e.target.value })} className="bg-gray-800 border-gray-700 text-white" /></div>
              <div className="space-y-2"><Label>Tür</Label><Input value={editPubData.type} onChange={(e) => setEditPubData({ ...editPubData, type: e.target.value })} className="bg-gray-800 border-gray-700 text-white" placeholder="Makale / Kongre / Tez" /></div>
            </div>
            <div className="space-y-2"><Label>Baslik</Label><Textarea value={editPubData.title} onChange={(e) => setEditPubData({ ...editPubData, title: e.target.value })} className="bg-gray-800 border-gray-700 text-white" rows={3} /></div>
            <div className="space-y-2"><Label>Dergi / Konferans</Label><Input value={editPubData.journal} onChange={(e) => setEditPubData({ ...editPubData, journal: e.target.value })} className="bg-gray-800 border-gray-700 text-white" /></div>
            <div className="space-y-2"><Label>DOI (opsiyonel)</Label><Input value={editPubData.doi} onChange={(e) => setEditPubData({ ...editPubData, doi: e.target.value })} className="bg-gray-800 border-gray-700 text-white" /></div>
          </div>
          <DialogFooter>
            <Button onClick={() => setEditPubDialog(false)} variant="ghost" className="text-gray-400">Iptal</Button>
            <Button onClick={savePub} className="bg-amber-600 hover:bg-amber-700">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Education Edit Dialog */}
      <Dialog open={editEduDialog} onOpenChange={setEditEduDialog}>
        <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle>{editEduIndex >= 0 ? 'Egitim Düzenle' : 'Yeni Egitim Ekle'}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2"><Label>Yil Araligi</Label><Input value={editEduData.year} onChange={(e) => setEditEduData({ ...editEduData, year: e.target.value })} className="bg-gray-800 border-gray-700 text-white" placeholder="2019 - 2021" /></div>
            <div className="space-y-2"><Label>Derece</Label><Input value={editEduData.deg} onChange={(e) => setEditEduData({ ...editEduData, deg: e.target.value })} className="bg-gray-800 border-gray-700 text-white" /></div>
            <div className="space-y-2"><Label>Okul</Label><Input value={editEduData.school} onChange={(e) => setEditEduData({ ...editEduData, school: e.target.value })} className="bg-gray-800 border-gray-700 text-white" /></div>
          </div>
          <DialogFooter>
            <Button onClick={() => setEditEduDialog(false)} variant="ghost" className="text-gray-400">Iptal</Button>
            <Button onClick={saveEdu} className="bg-amber-600 hover:bg-amber-700">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Expertise Edit Dialog */}
      <Dialog open={editExpDialog} onOpenChange={setEditExpDialog}>
        <DialogContent className="bg-gray-900 border-gray-800 text-white max-w-lg">
          <DialogHeader>
            <DialogTitle>{editExpIndex >= 0 ? 'Uzmanlik Düzenle' : 'Yeni Uzmanlik Ekle'}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div className="space-y-2"><Label>Baslik</Label><Input value={editExpData.title} onChange={(e) => setEditExpData({ ...editExpData, title: e.target.value })} className="bg-gray-800 border-gray-700 text-white" /></div>
            <div className="space-y-2"><Label>Aciklama</Label><Textarea value={editExpData.desc} onChange={(e) => setEditExpData({ ...editExpData, desc: e.target.value })} className="bg-gray-800 border-gray-700 text-white" rows={3} /></div>
          </div>
          <DialogFooter>
            <Button onClick={() => setEditExpDialog(false)} variant="ghost" className="text-gray-400">Iptal</Button>
            <Button onClick={saveExp} className="bg-amber-600 hover:bg-amber-700">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Full-Page Preview Modal */}
      {previewOpen && (
        <div className="fixed inset-0 z-[100] bg-[#0a0a0a] overflow-y-auto" data-testid="preview-modal">
          {/* Preview Header Bar */}
          <div className="sticky top-0 z-[110] bg-amber-600 text-white px-6 py-2 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
              <span className="font-medium text-sm">ÖNIZLEME MODU</span>
              <span className="text-xs opacity-80">Kaydedilmemis degisiklikler dahil</span>
            </div>
            <button onClick={() => setPreviewOpen(false)} className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-4 py-1.5 rounded text-sm transition-colors" data-testid="close-preview-btn">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
              Kapat
            </button>
          </div>

          {/* Hero */}
          <section className="relative min-h-[80vh] flex items-center">
            <div className="absolute inset-0 bg-gradient-to-br from-[#0a0a0a] via-[#111] to-[#0a0a0a]"></div>
            <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(255,255,255,0.15) 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
            <div className="relative z-10 max-w-6xl mx-auto px-6 w-full">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <div className="h-px w-16 bg-amber-500 mb-8"></div>
                  <h1 className="text-4xl md:text-5xl lg:text-6xl font-light leading-tight mb-6">
                    <span className="text-gray-400">Merhaba, Ben</span><br />
                    <span className="text-white font-medium">{content.hero_name}</span>{' '}
                    <span className="text-amber-400 font-medium">{content.hero_surname}</span>
                  </h1>
                  <p className="text-lg text-gray-400 leading-relaxed mb-8 max-w-lg">{content.hero_subtitle}</p>
                  <div className="flex flex-wrap gap-4">
                    <span className="px-8 py-3 border border-white/20 text-white tracking-wider text-sm cursor-default">HAKKIMDA</span>
                    <span className="px-8 py-3 bg-amber-600 text-white tracking-wider text-sm cursor-default">PLATFORMA GIRIS</span>
                  </div>
                </div>
                <div className="flex justify-center">
                  <div className="relative">
                    <div className="absolute -inset-4 bg-gradient-to-br from-amber-500/20 to-transparent rounded-2xl blur-xl"></div>
                    <img src="/cagatay-turna.png" alt="Preview" className="relative w-80 md:w-96 rounded-2xl shadow-2xl object-cover" style={{ aspectRatio: '3/4', objectPosition: 'center top' }} />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* About */}
          <section className="py-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0f0f0f] to-[#0a0a0a]"></div>
            <div className="relative z-10 max-w-6xl mx-auto px-6">
              <div className="text-center mb-16">
                <div className="h-px w-16 bg-amber-500 mx-auto mb-6"></div>
                <h2 className="text-3xl md:text-4xl font-light tracking-wider text-white">HAKKIMDA</h2>
              </div>
              <div className="grid md:grid-cols-2 gap-16 items-start">
                <div>
                  <p className="text-gray-400 leading-relaxed text-lg mb-6">{content.about_paragraph1}</p>
                  <p className="text-gray-400 leading-relaxed text-lg mb-8">{content.about_paragraph2}</p>
                  <h3 className="text-xl font-light tracking-wider text-amber-400 mb-4">Egitim</h3>
                  <div className="space-y-3 mb-8">
                    {(content.education || []).map((e, i) => (
                      <div key={i} className="flex gap-4 items-start">
                        <span className="text-xs text-amber-400 whitespace-nowrap mt-1 w-28">{e.year}</span>
                        <div><p className="text-white text-sm">{e.deg}</p><p className="text-gray-500 text-xs">{e.school}</p></div>
                      </div>
                    ))}
                  </div>
                  <div className="grid grid-cols-3 gap-6">
                    {(content.stats || []).map((stat, i) => (
                      <div key={i} className="text-center p-4 border border-gray-800 rounded-lg">
                        <div className="text-2xl font-bold text-amber-400">{stat.value}</div>
                        <div className="text-xs text-gray-500 mt-1">{stat.label}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="space-y-6">
                  <h3 className="text-xl font-light tracking-wider text-amber-400 mb-4">Uzmanlik Alanlari</h3>
                  {(content.expertise || []).map((item, i) => (
                    <div key={i} className="p-5 border border-gray-800 rounded-lg">
                      <h4 className="text-white font-medium mb-1">{item.title}</h4>
                      <p className="text-sm text-gray-500">{item.desc}</p>
                    </div>
                  ))}
                  <h3 className="text-xl font-light tracking-wider text-amber-400 mb-3 mt-8">Teknik Yazilimlar</h3>
                  <div className="flex flex-wrap gap-2">
                    {(content.technical_software || []).map((s, i) => (
                      <span key={i} className="text-xs bg-gray-800 text-gray-300 px-3 py-1.5 rounded border border-gray-700">{s}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Publications */}
          <section className="py-24 relative">
            <div className="absolute inset-0 bg-[#0a0a0a]"></div>
            <div className="relative z-10 max-w-6xl mx-auto px-6">
              <div className="text-center mb-16">
                <div className="h-px w-16 bg-amber-500 mx-auto mb-6"></div>
                <h2 className="text-3xl md:text-4xl font-light tracking-wider text-white">YAYINLARIM</h2>
              </div>
              <div className="space-y-6">
                {(content.publications || []).map((pub, i) => (
                  <div key={i} className="p-6 border border-gray-800 rounded-lg flex gap-6">
                    <div className="flex-shrink-0 text-center">
                      <div className="text-2xl font-bold text-amber-400">{pub.year}</div>
                      <div className={`text-xs mt-1 px-2 py-0.5 rounded ${pub.type === 'Makale' ? 'bg-blue-900/50 text-blue-300' : pub.type === 'Tez' ? 'bg-purple-900/50 text-purple-300' : 'bg-green-900/50 text-green-300'}`}>{pub.type}</div>
                    </div>
                    <div>
                      <h3 className="text-white font-medium mb-1">{pub.title}</h3>
                      <p className="text-sm text-gray-500">{pub.journal}</p>
                      {pub.doi && <p className="text-xs text-amber-600 mt-1">DOI: {pub.doi}</p>}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Platform CTA */}
          <section className="py-20 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-900/20 via-amber-800/10 to-amber-900/20"></div>
            <div className="absolute inset-0 bg-[#0a0a0a]/80"></div>
            <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
              <h2 className="text-3xl md:text-4xl font-light tracking-wider text-white mb-4">{content.platform_title}</h2>
              <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">{content.platform_description}</p>
              <span className="px-10 py-4 bg-amber-600 text-white tracking-wider text-sm inline-flex items-center gap-3 cursor-default">
                PLATFORMA GIRIS YAP
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
              </span>
            </div>
          </section>

          {/* Contact */}
          <section className="py-24 relative">
            <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0f0f0f] to-[#0a0a0a]"></div>
            <div className="relative z-10 max-w-6xl mx-auto px-6">
              <div className="text-center mb-16">
                <div className="h-px w-16 bg-amber-500 mx-auto mb-6"></div>
                <h2 className="text-3xl md:text-4xl font-light tracking-wider text-white">ILETISIM</h2>
              </div>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-6 max-w-4xl mx-auto">
                <div className="text-center p-6 border border-gray-800 rounded-lg">
                  <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                  <p className="text-sm text-gray-400">{content.contact_email}</p>
                </div>
                <div className="text-center p-6 border border-gray-800 rounded-lg">
                  <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                  <p className="text-sm text-gray-400">{content.contact_phone}</p>
                </div>
                <div className="text-center p-6 border border-gray-800 rounded-lg">
                  <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
                  <p className="text-sm text-gray-400">{content.contact_instagram_handle}</p>
                </div>
                <div className="text-center p-6 border border-gray-800 rounded-lg">
                  <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                  <p className="text-sm text-gray-400">{content.contact_linkedin_handle}</p>
                </div>
                <div className="text-center p-6 border border-gray-800 rounded-lg">
                  <svg className="w-8 h-8 mx-auto mb-3 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                  <p className="text-sm text-gray-400">{content.contact_location}</p>
                </div>
              </div>
            </div>
          </section>

          {/* Footer */}
          <footer className="py-8 border-t border-gray-800/50">
            <div className="max-w-6xl mx-auto px-6 text-center">
              <p className="text-sm text-gray-600">&copy; {content.footer_text}</p>
            </div>
          </footer>
        </div>
      )}
    </div>
  );
};

export default SiteAdminPage;
